module.exports = __webpack_public_path__ + "static/prepped-mobile-3-2ee1a647b22ca2a8fc918e4aa82778b3.jpg";